export const showFilters = [
    { value: 0, description: 'To Do' },
    { value: 1, description: 'All Active Cases' },
    { value: 2, description: 'Closed Cases' },
    { value: 3, description: 'All Cases' },
];